import { FC } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'

const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

const Label = styled.span`
  color: ${({ theme }) => theme.color.darkGreen};
`

const Amount = styled.span`
  color: ${({ theme }) => theme.color.darkGreen};
  white-space: nowrap;
`

export interface DiscountTotalsLineProps {
  code: string
  percent: number
  amount: string
}

export const DiscountTotalsLine: FC<DiscountTotalsLineProps> = ({
  code,
  percent,
  amount,
}) => (
  <Line>
    <Label>
      Promo {code} ({percent}%)
    </Label>
    <Amount>- {amount}</Amount>
  </Line>
)
